module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	"use strict";

	fox.registerWidget('SitePage_Registration_Step2', {
		configure: function () {
			this.registerOptions('', {
				'widgets.registration': {
					widget: 'Registration_Form'
				}
			});

			this.callParent('configure', arguments);
		}
	}, 'Site_Page');
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/sitepage/registration/step2.js
// module id = 357
// module chunks = 2